import React from "react";
import Dashboard from "../Dashboard/Dashboard";

function LoggedInHome() {
  return <Dashboard />;
}

export default LoggedInHome;